import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { API_BASE_URL } from '../config';

const SignupLogo = () => (
  <div style={{ textAlign: 'center', marginBottom: 32 }}>
    <img 
      id="imager11" 
      src="/nlogo.png" 
      alt="Reliable Mechanics Logo"
    />
  </div>
);

const LockIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 8, minWidth: 22 }}>
    <rect x="3" y="11" width="18" height="10" rx="4" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [referralValid, setReferralValid] = useState<boolean | null>(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    // Check for referral code in URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get('ref');
    if (refCode) {
      setReferralCode(refCode.toUpperCase());
      validateReferralCode(refCode);
    }
  }, []);

  const validateReferralCode = async (code: string) => {
    if (!code.trim()) {
      setReferralValid(null);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/referral/validate-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ referralCode: code })
      });

      const data = await response.json();
      if (data.success) {
        setReferralValid(data.valid);
      } else {
        setReferralValid(false);
      }
    } catch (error) {
      console.error('Error validating referral code:', error);
      setReferralValid(false);
    }
  };

  const handleReferralCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value.toUpperCase();
    setReferralCode(code);
    if (code.length >= 6) {
      validateReferralCode(code);
    } else {
      setReferralValid(null);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
             const res = await fetch(`${API_BASE_URL}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, password, referralCode: referralCode || undefined })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Signup failed');
      setSuccess('Signup successful! Please login.');
      setTimeout(() => navigate('/login'), 1200);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <>
      <style>{`
        @media (max-width: 600px) {
          .login-card {
            padding: 18px !important;
            border-radius: 8px !important;
            min-width: 0 !important;
            width: 100% !important;
          }
          .login-card input {
            font-size: 0.98rem !important;
            padding: 8px 10px !important;
            border-radius: 6px !important;
          }
        }
        .login-card input {
          width: 100%;
          box-sizing: border-box;
          min-width: 0;
          max-width: 100%;
        }
      `}</style>
      <Navbar/>
      <div id="rrre">
      <div  id="hhht"style={{ background: '#111', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 0' }}>
        <SignupLogo />
        <h2 style={{ color: '#fff', fontWeight: 700, fontSize: '2rem', marginBottom: 32, textAlign: 'center' }}>Sign Up</h2>
        <form className="login-card" onSubmit={handleSubmit} style={{ background: '#181818', borderRadius: 16, boxShadow: '0 4px 24px #0006', padding: 32, minWidth: 340, maxWidth: 380, width: '100%', display: 'flex', flexDirection: 'column', gap: 18 }}>
          <label htmlFor="name" style={{ color: '#eaeaea', fontWeight: 500, marginBottom: 4 }}>Name</label>
          <input id="name" name="name" type="text" value={name} onChange={e => setName(e.target.value)} required style={{ background: '#111', color: '#eaeaea', border: '1.5px solid #232323', borderRadius: 8, padding: '10px 14px', fontSize: '1rem', marginBottom: 8 }} />
          <label htmlFor="email" style={{ color: '#eaeaea', fontWeight: 500, marginBottom: 4 }}>Email</label>
          <input id="email" name="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required style={{ background: '#111', color: '#eaeaea', border: '1.5px solid #232323', borderRadius: 8, padding: '10px 14px', fontSize: '1rem', marginBottom: 8 }} />
          <label htmlFor="password" style={{ color: '#eaeaea', fontWeight: 500, marginBottom: 4 }}>Password</label>
          <input id="password" name="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required style={{ background: '#111', color: '#eaeaea', border: '1.5px solid #232323', borderRadius: 8, padding: '10px 14px', fontSize: '1rem', marginBottom: 8 }} />
          
          <label htmlFor="referralCode" style={{ color: '#eaeaea', fontWeight: 500, marginBottom: 4 }}>Referral Code (Optional)</label>
          <input 
            id="referralCode" 
            name="referralCode" 
            type="text" 
            value={referralCode} 
            onChange={e => {
              setReferralCode(e.target.value.toUpperCase());
              validateReferralCode(e.target.value);
            }}
            placeholder="Enter referral code"
            style={{ 
              background: '#111', 
              color: '#eaeaea', 
              border: referralValid === false ? '1.5px solid #ff4444' : referralValid === true ? '1.5px solid #44ff44' : '1.5px solid #232323', 
              borderRadius: 8, 
              padding: '10px 14px', 
              fontSize: '1rem', 
              marginBottom: 8 
            }} 
          />
          {referralValid === false && (
            <div style={{ color: '#ff4444', fontSize: '0.9rem', marginBottom: 8 }}>
              Invalid referral code
            </div>
          )}
          {referralValid === true && (
            <div style={{ color: '#44ff44', fontSize: '0.9rem', marginBottom: 8 }}>
              Valid referral code! The referrer will get $5 bonus after your first booking.
            </div>
          )}
          {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
          {success && <div style={{ color: 'green', marginBottom: 8 }}>{success}</div>}
          <button type="submit" style={{ background: '#ffd600', color: '#111', fontWeight: 600, border: 'none', borderRadius: 8, padding: '12px 0', fontSize: '1.1rem', marginTop: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, boxShadow: '0 2px 8px #0003' }}>
            <LockIcon /> Sign Up
          </button>
        </form>
      </div>
      <Footer/>
      </div>
    </>
  );
};

export default SignupPage; 